export const RES = 'trackReAffiliateIds';
export const AFFILIATES = 'affiliates';

export const DAYS = 'inactivityPeriodDays';
export const IMPRESSION = 'impressionPeriodDays';
export const CLICK = 'clickPeriodDays';
export const RECURRING = 'recurringRemarketingPeriodDays';

export const RE_ENGAGEMENT = 'defaultTrackRe';
